import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProductCatalog from './pages/product-catalog';
import ProductDetailPage from './pages/product-detail-page';
import IndividualPeptideProductPages from './pages/individual-peptide-product-pages';
import PaymentInstructions from './pages/payment-instructions';
import Checkout from './pages/checkout';
import OrderConfirmation from './pages/order-confirmation';
import Homepage from './pages/homepage';
import Contact from './pages/contact';
import ShoppingCart from './pages/shopping-cart';
import PeptideCalculator from './pages/peptide-calculator';
import SavedCalculations from './pages/saved-calculations';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* All Routes - No Authentication Required */}
        <Route path="/" element={<Homepage />} />
        <Route path="/product-catalog" element={<ProductCatalog />} />
        <Route path="/product/:id" element={<IndividualPeptideProductPages />} />
        <Route path="/product-detail-page" element={<ProductDetailPage />} />
        <Route path="/payment-instructions" element={<PaymentInstructions />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/peptide-calculator" element={<PeptideCalculator />} />
        <Route path="/saved-calculations" element={<SavedCalculations />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
